import {
  Route as ReactRoute,
  Redirect as ReactRedirect,
  RouteProps as ReactRouteProps,
} from 'react-router-dom';

import { ROUTES } from 'shared/constants';
import { useHasSession } from 'shared/hooks';
import { recordDebug } from 'shared/utils/record';

type RouteProps = ReactRouteProps & {
  /**
   * `private` means route available only for authorized users
   * `public` means route available only for not-authorized users
   * `any` means route available for any users
   */
  authAccess: 'private' | 'public' | 'any';
  title?: string;
};

export const Route = ({ authAccess, children, ...rest }: RouteProps) => {
  const hasSession = useHasSession();

  if (hasSession && authAccess === 'public') {
    recordDebug('User with active session tried to access public route');
    return <ReactRedirect to="/" />;
  }

  if (!hasSession && authAccess === 'private') {
    recordDebug('User without active session tried to access private route');
    return <ReactRedirect to={ROUTES.public.login} />;
  }

  return <ReactRoute {...rest}>{children}</ReactRoute>;
};
